import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const activeLoansSlice = createSlice({
  name: "activeLoans",

  initialState: { activeLoans: [], activeLoanLoader: false },
  reducers: {
    setAllActiveLoans: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.activeLoans = payload;
    },
    setAllActiveLoansLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.activeLoanLoader = payload;
    },
    resetAllActiveLoans: (state) => {
      state.activeLoans = [];
    },
  },
});

export const {
  setAllActiveLoans,
  resetAllActiveLoans,
  setAllActiveLoansLoader,
} = activeLoansSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default activeLoansSlice.reducer;
